export default __webpack_public_path__ + "static/media/slot_scheduling.d0e057e6.png";